import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { POSTS } from "@/lib/posts";
import { formatDate } from "@/lib/markdown";
import { websiteJsonLd, webPageJsonLd, breadcrumbJsonLd, categoryImage } from "@/data/site";

const TITLE = "Blog — Guide di Medicina del Lavoro | BPMedLav Roma";
const DESCRIPTION =
  "Guide e approfondimenti su sorveglianza sanitaria, D.Lgs 81/08, videoterminalisti e primo soccorso aziendale, a cura dei medici competenti di BPMedLav Roma.";

export default function BlogIndex() {
  return (
    <>
      <Seo
        title={TITLE}
        description={DESCRIPTION}
        path="/blog"
        jsonLd={[
          websiteJsonLd(),
          webPageJsonLd({ path: "/blog", title: TITLE, description: DESCRIPTION }),
          breadcrumbJsonLd([
            { name: "Home", path: "/" },
            { name: "Blog", path: "/blog" },
          ]),
        ]}
      />
      <main className="bg-paper pt-28 md:pt-36 pb-24 md:pb-32 min-h-screen">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <Reveal>
            <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-clinic mb-6">
              Blog — Guide e approfondimenti
            </p>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-ink max-w-3xl mb-6">
              Medicina del lavoro, spiegata semplice.
            </h1>
            <p className="text-base md:text-lg text-ink/70 max-w-2xl mb-16">
              Obblighi, scadenze e buone pratiche per datori di lavoro, HR e RSPP: risposte
              dirette scritte dai medici competenti Dr. Buomprisco e Dr. Perri.
            </p>
          </Reveal>

          <div className="grid gap-px bg-ink/10 border border-ink/10 md:grid-cols-2">
            {POSTS.map((post, i) => (
              <Reveal key={post.slug} delay={i * 0.06} className="bg-paper">
                <Link
                  to={`/blog/${post.slug}`}
                  data-testid={`blog-card-${post.slug}`}
                  className="group flex h-full flex-col bg-paper transition-colors hover:bg-clinic-tint/60"
                >
                  <div className="h-48 overflow-hidden border-b border-ink/10">
                    <img
                      src={categoryImage(post.category)}
                      alt={`Medicina del lavoro — ${post.category}`}
                      className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="flex flex-1 flex-col p-8 md:p-10">
                  <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-clinic mb-4">
                    {post.category}
                  </p>
                  <h2 className="font-display text-2xl md:text-3xl leading-snug text-ink group-hover:text-clinic transition-colors mb-4">
                    {post.title}
                  </h2>
                  <p className="text-sm md:text-base leading-relaxed text-ink/60 mb-8">
                    {post.description}
                  </p>
                  <p className="mt-auto pt-6 font-mono text-[10px] tracking-[0.15em] uppercase text-ink/40">
                    {post.author} · Agg. {formatDate(post.dateModified)} · {post.readingTime}
                  </p>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </main>
    </>
  );
}
